import type { HTMLAttributes } from 'react'
import { cn } from '../../lib/cn'

/** Pill. Default is black (content/done). Status tones use soft bg + ink text. */
export type BadgeVariant = 'default' | 'secondary' | 'outline' | 'volt' | 'success' | 'warning' | 'destructive'
const variants: Record<BadgeVariant, string> = {
  default: 'bg-foreground text-background',
  secondary: 'bg-secondary text-secondary-foreground',
  outline: 'border border-border text-foreground',
  volt: 'bg-volt-soft text-volt-ink',
  success: 'bg-success-soft text-success-ink',
  warning: 'bg-warning-soft text-warning-ink',
  destructive: 'bg-destructive-soft text-destructive',
}
export function Badge({ className, variant = 'default', ...props }: HTMLAttributes<HTMLSpanElement> & { variant?: BadgeVariant }) {
  return <span className={cn('inline-flex h-5 shrink-0 items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium whitespace-nowrap [&_svg]:size-3', variants[variant], className)} {...props} />
}

/** Status box (alert): soft background, ink text, 40% border. */
export function StatusBox({ tone = 'volt', className, ...props }: HTMLAttributes<HTMLDivElement> & { tone?: 'volt' | 'success' | 'warning' | 'destructive' }) {
  const tones = {
    volt: 'border-foreground/20 bg-volt-soft text-volt-ink',
    success: 'border-success/40 bg-success-soft text-success-ink',
    warning: 'border-warning/40 bg-warning-soft text-warning-ink',
    destructive: 'border-destructive/40 bg-destructive-soft text-destructive',
  }
  return <div role="status" className={cn('rounded-xl border px-3 py-2.5 text-sm', tones[tone], className)} {...props} />
}
